import React from 'react';

const ScooterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M21 19.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5Zm-15 0a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5ZM18.42 17H6.58L9.22 9.61l6.76 2.17L18.42 17ZM16.4 8l-7.94-2.55-1.3 4.05 1.14.37.93-2.89 7.94 2.55.37-1.16-.74-.24v-.13Z"/>
  </svg>
);

export default ScooterIcon;
